import React, { useEffect, useRef } from "react";
import QRCode from "qrcode";

interface QRCodeDisplayProps {
  value: string;
  size?: number;
  className?: string;
}

const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({
  value,
  size = 200,
  className = "",
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current && value) {
      // Optimizar configuración para múltiples productos
      const options = {
        width: size,
        margin: 1, // Reducir margen para más espacio
        color: {
          dark: "#000000",
          light: "#FFFFFF",
        },
        errorCorrectionLevel: 'M', // Nivel medio de corrección de errores
        type: 'image/png',
        quality: 0.92,
        rendererOpts: {
          quality: 1
        }
      };

      QRCode.toCanvas(canvasRef.current, value, {
        ...options,
        errorCorrectionLevel: 'M' as QRCode.QRCodeErrorCorrectionLevel
      }).catch((err) => {
        console.error("Error generating QR code:", err);
      });
    }
  }, [value, size]);

  if (!value) {
    return (
      <div
        className={`bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center border-2 border-dashed border-gray-300 dark:border-gray-600 ${className}`}
        style={{ width: size, height: size }}
      >
        <div className="text-center text-gray-500">
          <div className="text-4xl mb-2">📱</div>
          <div className="text-sm">QR no disponible</div>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <canvas
        ref={canvasRef}
        style={{ width: size, height: size }}
        className="rounded-lg border border-gray-200 dark:border-gray-700"
      />
    </div>
  );
};

export default QRCodeDisplay;
